export type ViewType = 'manager' | 'employee' | 'hr'

export interface UserConfig {
    displayName: string
    color: string
    description: string
    defaultRoute: string
}

export const USER_CONFIGS: Record<ViewType, UserConfig> = {
    hr: {
        displayName: 'HR',
        color: 'bg-red-500',
        description: 'Strategic HR functions',
        defaultRoute: '/hr/dashboard',
    },
    manager: {
        displayName: 'Manager',
        color: 'bg-primary',
        description: 'Team management',
        defaultRoute: '/manager/team-overview',
    },
    employee: {
        displayName: 'Employee',
        color: 'bg-teal-500',
        description: 'Personal workspace',
        defaultRoute: '/employee/dashboard',
    },
}

export const getUserDisplayName = (userType: ViewType): string => {
    return USER_CONFIGS[userType].displayName
}

export const getUserColor = (userType: ViewType): string => {
    return USER_CONFIGS[userType].color
}

export const getUserDescription = (userType: ViewType): string => {
    return USER_CONFIGS[userType].description
}
